import React from 'react';
import { SelectFieldValue } from '@sections/chat-gpt/Form/Form.types';
import { SelectWrapper, StyledDropdown } from './GPTSelect.styles';

export interface SelectProps {
  preSelectedOption: SelectFieldValue;
  options: SelectFieldValue[];
  onClickedOption: (selectedOption: SelectFieldValue, index: number) => void;
}

const encodeOptionValue = (index: number, label: string, value: string): string => {
  return [index, label, value].join(',');
};

const decodeOptionValue = (optionValue: string): { index: number; label: string; value: string } => {
  const [index, label, value] = optionValue.split(',');
  return {
    index: Number(index),
    label,
    value,
  };
};

export const GPTSelect = (props: SelectProps) => {
  const { preSelectedOption, options, onClickedOption } = props;

  return (
    <SelectWrapper>
      <StyledDropdown
        aria-label="GPT Select"
        onChange={(e) => {
          const { index, label, value } = decodeOptionValue(e.target.value);
          onClickedOption({ label, value }, index);
        }}
        defaultValue={preSelectedOption.label}
      >
        {options.map((opt, index) => (
          <option key={index} value={encodeOptionValue(index, opt.label, opt.value)}>
            {opt.label}
          </option>
        ))}
      </StyledDropdown>
    </SelectWrapper>
  );
};
